class Test {
	constructor(options) {
		this.questions = options.questions;
		this.$btn = $(".test__button");
		this.$answers = $(".test__answers");
		this.$question = $(".test__question");
		this.answers = {
			physicals: 0,
			emotions: 0,
			sexual: 0,
			beauty: 0,
			sleep: 0,
		};
		this.activeIndex = 0;
		this.showResults = false;
		this.resultIndex = 0;
		this.isActive = false;
		this.ready = false;
	}
	init() {
		this.bindEvents();
		this.renderQuestion();
	}

	bindEvents() {
		$(window).on("load", () => {
			const delay = 200;
			$("body,html").animate(
				{
					scrollTop: 0,
				},
				delay
			);
			setTimeout(() => {
				this.ready = true;
			}, delay * 2);
		});
		$(".info__arrow").on("click", function () {
			$([document.documentElement, document.body]).animate(
				{
					scrollTop: $(".test").offset().top,
				},
				500
			);
		});
		this.$btn.on("click", this.handleClick);
		$(window).on("scroll", this.handleScroll);
	}

	handleScroll = () => {
		if (!this.isActive && this.ready) {
			$([document.documentElement, document.body]).animate(
				{
					scrollTop: $(".test").offset().top,
				},
				500
			);
			this.isActive = true;
		}
	};

	handleClick = (e) => {
		if (this.showResults) {
			return;
		}
		const value = $(e.target).text();
		const category = $(e.target).attr("data-key");
		if (value === "да") {
			this.answers[category] += 1;
		}

		if (this.activeIndex >= this.questions.length - 1) {
			this.showResults = true;
			this.detectResultIndex();
			this.renderResults();
		} else {
			this.activeIndex += 1;
			this.renderQuestion();
		}
	};

	detectResultIndex() {
		const winnerArray = [];
		let maxValue = 0;
		for (const [key, value] of Object.entries(this.answers)) {
			if (value > maxValue) {
				maxValue = value;
			}
		}
		for (const [key, value] of Object.entries(this.answers)) {
			if (maxValue && value === maxValue) {
				winnerArray.push(key);
			}
		}
		if (
			winnerArray.indexOf("physicals") >= 0 &&
			winnerArray.indexOf("sexual") >= 0
		) {
			this.resultIndex = 0;
		} else if (
			winnerArray.indexOf("physicals") >= 0 &&
			winnerArray.indexOf("sleep") >= 0
		) {
			this.resultIndex = 1;
		} else if (
			winnerArray.indexOf("physicals") >= 0 &&
			winnerArray.indexOf("emotions") >= 0
		) {
			this.resultIndex = 2;
		} else if (
			winnerArray.indexOf("physicals") >= 0 &&
			winnerArray.indexOf("beauty") >= 0
		) {
			this.resultIndex = 3;
		} else if (
			winnerArray.indexOf("beauty") >= 0 &&
			winnerArray.indexOf("sexual") >= 0
		) {
			this.resultIndex = 4;
		} else if (winnerArray.indexOf("physicals") >= 0) {
			this.resultIndex = 5;
		} else if (winnerArray.indexOf("emotions") >= 0) {
			this.resultIndex = 6;
		} else if (winnerArray.indexOf("sexual") >= 0) {
			this.resultIndex = 7;
		} else if (winnerArray.indexOf("beauty") >= 0) {
			this.resultIndex = 8;
		} else if (winnerArray.indexOf("sleep") >= 0) {
			this.resultIndex = 9;
		} else {
			this.resultIndex = 0;
		}
	}

	renderQuestion() {
		this.$question.html(this.questions[this.activeIndex].q);
		this.$btn.attr("data-key", this.questions[this.activeIndex].category);
	}

	renderResults() {
		$("body").addClass("show-results");
		$([document.documentElement, document.body]).animate(
			{
				scrollTop: $(".health").offset().top,
			},
			500
		);
		$(".health__title").html(RESULTS[this.resultIndex].title);
		$(".health__text").html(RESULTS[this.resultIndex].text);
		$(".health__desc").html(RESULTS[this.resultIndex].desc);
		$(".advice__text").html(RESULTS[this.resultIndex].advice);
		$(".advice__autor").html(RESULTS[this.resultIndex].adviceAuthor);
		$(".advice__link").html(RESULTS[this.resultIndex].link);
		$(".sponsor__text").html(RESULTS[this.resultIndex].sponsorName);
		$(".sponsor__right").html("");
		RESULTS[this.resultIndex].list.forEach(({ title, items }, id) => {
			$(".sponsor__right").append(
				`<p class="sponsor__consist">${title}</p>`
			);
			$(".sponsor__right").append(`<ul class="sponsor__list"></ul>`);
			items.forEach((item) => {
				$(".sponsor__list")
					.eq(id)
					.append(`<li class="sponsor__item">${item}</li>`);
			});
		});
	}
}

export default Test;



// WEBPACK FOOTER //
// ./app/scripts/test.js